export default "__VITE_ASSET__DBPKquhX__"